import { render, staticRenderFns } from "./TfacStudentInfoPage.vue?vue&type=template&id=2cb495ab"
import script from "./TfacStudentInfoPage.vue?vue&type=script&lang=js"
export * from "./TfacStudentInfoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports